// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D3baIsA","header":"_5D1oY0eB","main":"_5D3tXdx2","form":"_5D1ftH3f","link":"_5D39hwJO","sso":"_5D5soMD1"};